export default class Pagination {
    static getLastUrl(dataCount: number, url: string) {
        const numberOfPages = this.getNumberOfPages(dataCount);
        const char = url.includes('?') ? '&' : '?';
        const pageQueryString = `${char}page=${numberOfPages}`;
        return url.concat(pageQueryString);
    }
    
    static getUrlAt(page: number, url: string) {
        let char = url.includes('?') ? '&' : '?';
        const pageQueryString = `${char}page=${page}`;
        if (url.includes('page')) return url.replace(/page=\d+/, pageQueryString);
        return url.concat(pageQueryString);
    }
    
    private static getNumberOfPages(count: number) {
        return Math.ceil(count / 15);
    }
}